#import "./fragments/personFragment.graphql"
#import "./fragments/personFilledPositionsFragment.graphql"
#import "./fragments/teamFragment.graphql"
#import "./fragments/tagFragment.graphql"

query globalSearchQuery(
  $searchTerms: [String]
  $size: Int
  $filter: InsightFilter
  $includePeople: Boolean! = true
  $includeGroups: Boolean! = true
  $includeTags: Boolean! = false
  $includePositions: Boolean! = false
  $includePositionFields: Boolean = false
  $personFieldsToSearch: [PersonFieldsToSearch]
  $positionFieldsToSearch: [PersonFieldsToSearch]
  $positionOccupancyStatus: [PositionOccupancyStatus!]
  $groupFieldsToSearch: [GroupFieldsToSearch]
  $tagFieldsToSearch: [TagFieldsToSearch]
  $personSearchAfterId: [String]
  $tagsOffset: Int = 0
  $groupsOffset: Int = 0
  $positionsPage: Int
  $includeEmptyGroups: Boolean = false
) {
  result: globalSearch(
    tagsOffset: $tagsOffset
    groupsOffset: $groupsOffset
    positionsPage: $positionsPage
    positionOccupancyStatus: $positionOccupancyStatus
    positionFieldsToSearch: $positionFieldsToSearch
    size: $size
    searchTerms: $searchTerms
    filter: $filter
    personFieldsToSearch: $personFieldsToSearch
    groupFieldsToSearch: $groupFieldsToSearch
    tagFieldsToSearch: $tagFieldsToSearch
    personSearchAfterId: $personSearchAfterId
    includeTags: $includeTags
    includePeople: $includePeople
    includeGroups: $includeGroups
    includePositions: $includePositions
    includeEmptyGroups: $includeEmptyGroups
  ) {
    pagedPeople @include(if: $includePeople) {
      totalCount
      searchAfterId
      people {
        ...GlobalSearchPersonBaseFragment
        ...PersonFilledPositionsFragment @include(if: $includePositionFields)
        __typename
      }
      __typename
    }

    pagedPositions @include(if: $includePositions) {
      totalCount
      positions {
        id
        occupancyStatus
        startDate
        endDate
        person {
          aggregateId
          preferredName
          firstName
          surname
          avatar
          isVacancy
          __typename
        }
        incumbents {
          aggregateId
          preferredName
          firstName
          surname
          avatar
          __typename
        }
        supplyTeam {
          id
          name
          type
          __typename
        }
        __typename
      }
      __typename
    }

    pagedGroups @include(if: $includeGroups) {
      totalCount
      groups {
        ...TeamFragment
        __typename
      }
      __typename
    }

    pagedTags @include(if: $includeTags) {
      totalCount
      tags {
        ...TagMinimalFragment
        __typename
      }
      __typename
    }
  }
}
